<template>
  <div class="container">
    <div class="ex-activity">
      <ul class="activityList">
        <li class="activity-list" :class="{'hotActivityList':tapHot}" @click="changeHot">
          热门活动
        </li>
        <li class="activity-list" :class="{'hotActivityList':!tapHot}" @click="changeHot">
          全部活动
        </li>
      </ul>
    </div>
    <div class="hot_activityList">
      <ul class="hotact-list" v-if="tapHot">
        <li class="hotactList" v-for="item in list" v-if="item.hot == 1">
          <a class="hotactImg" :href="item.redirectUrl"><img :src="item.imgUrl"/></a>
          <div class="hotDesc">
            <p>{{item.title}}</p><span>{{item.status}}<i class="enter-icon"></i></span>
          </div>
          <div class="enterNum">
            <span>已有{{item.joinCount}}人参加</span>
          </div>
        </li>
      </ul>
      <ul class="hotact-list" v-else>
        <li class="hotactList" v-for="item in list">
          <a class="hotactImg" :href="item.redirectUrl"><img :src="item.imgUrl"/></a>
          <div class="hotDesc">
            <p>{{item.title}}</p><span>{{item.status}}<i class="enter-icon"></i></span>
          </div>
          <div class="enterNum">
            <span>已有{{item.joinCount}}人参加</span>
          </div>
        </li>
      </ul>
    </div>
    <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import aghm from '../../api/aghm.js'
import home from '../common/home.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
  data () {
    return {
        list:[],
        tapHot:true,
        tipDialog:false,
        tipText:'',
    }
  },
  components:{
    XDialog,
    home
  },
  computed:{
  	 ...mapGetters({
    }),

  },
  watch:{

  },
  created(){
    aghm.getActivityList().then((res) =>{
      if(res.data.errno){
          alert(res.data.error)
      }else{
          let data = res.data.body;
          this.list = data
      }
    },(error) =>{
      this.showMsg(error)
    })
  },
  methods:{
      changeHot(e){
          let obj = e.target;
          if(obj.className.indexOf('hotActivityList') == -1){
              this.tapHot = !this.tapHot
          }
      },
      showMsg(txt){
        this.tipText=txt;
        this.tipDialog=true;
      }
  },
  mounted(){}
}
</script>